export const chemistryData = {
  departmentName: "Department of Chemistry",
  bannerImage: "/infrastructure/chemistry/lab-6.JPG",

  about: {
    title: "About the Department",
    content: `The Department of Chemistry at Rayalaseema University provides quality education in chemical sciences 
    with emphasis on theoretical and practical aspects. We offer comprehensive programs covering organic, inorganic, 
    physical, and analytical chemistry. Our department is committed to fostering scientific temper, research aptitude, 
    and practical skills essential for careers in pharmaceuticals, chemical industries, research, and academics.`,
    highlights: [
      "Modern analytical instruments and spectroscopy facilities",
      "Well-equipped laboratories for all branches of chemistry",
      "Research in organic synthesis and inorganic chemistry",
      "Industry collaborations and placement opportunities"
    ]
  },

  // brochure: {
  //   title: "Department Brochure",
  //   pdfLink: "/chemistry/department-brochure.pdf",
  //   description: "Download our comprehensive department brochure for detailed information about programs, facilities, and achievements."
  // },

  hod: {
    name: "Prof. M. E. Rani",
    designation: "Professor & Head",
    photo: "/chemistry/ProfRani.png",
    email: "drmerani@gmail.com",
    mobile: "9705236392",
    qualification: "M.Sc., Ph.D.",
    specialization: "Organic Chemistry, Preparation of bio plastics, Plant mediated nano particals ",
    message: `Welcome to the Department of Chemistry at Rayalaseema University. We are committed to excellence 
    in chemical education and research. Our department strives to develop skilled chemists who can contribute to 
    scientific advancement and industrial innovation.`,
    profileLink: "/chemistry/M-E-RANI.pdf"
  },

  bos: {
  title: "Chemistry",
  members: [
    {
      name: "Prof. K.S.V. Krishna Rao",
      designation: "Chairperson",
      affiliation: "Dept. of Chemistry, Yogi Vemana University, Kadapa"
    },
    {
      name: "Prof. M. Esther Rani",
      designation: "Member",
      affiliation: "Dept. of Chemistry, Rayalaseema University, Kurnool"
    },
    {
      name: "Prof. M.V. Basaveswara Rao",
      designation: "Member",
      affiliation: "Krishna University, Machilipatnam"
    },
    {
      name: "Prof. C. Suresh Reddy",
      designation: "Member",
      affiliation: "Dept. of Chemistry, S.V. University, Tirupati"
    },
    {
      name: "Dr. L. Subramanya Sharma",
      designation: "Member",
      affiliation: "Dept. of Chemistry, Yogi Vemana University, Kadapa"
    },
    {
      name: "Dr. Hari Babu",
      designation: "Member",
      affiliation: "Acharya Nagarjuna University, Guntur"
    },
    {
      name: "Mr. Kishor Addanki",
      designation: "Member",
      affiliation: "Senior Manager, Shilpa Medicare Ltd., Karnataka"
    }
  ]
}
,

  faculty: [
    {
      name: "Prof. M. E. Rani",
      designation: "Professor & Head",
      email: "drmerani@gmail.com",
      mobile: "9705236392",
      photo: "/chemistry/ProfRani.png",
      qualification: "M.Sc., Ph.D.",
      specialization: "Organic Chemistry, Preparation of bio plastics, Plant mediated nano particals ",
       
       profileLink: "/chemistry/M-E-RANI.pdf"
    }
  ],

  courses: {
    // undergraduate: [
    //   {
    //     name: "B.Sc. Chemistry",
    //     duration: "3 Years",
    //     eligibility: "10+2 with Chemistry",
    //     intake: "60 seats"
    //   }
    // ],
    postgraduate: [
      {
        name: "M.Sc. Chemistry",
        duration: "2 Years",
        eligibility: "B.Sc. with Chemistry",
        intake: "30 seats"
      }
    ],
    research: [
      {
        name: "Ph.D. in Chemistry",
        duration: "Minimum 3 Years",
        eligibility: "M.Sc. Chemistry",
        areas: "Organic, Inorganic, Physical, Analytical Chemistry"
      }
    ]
  },

  Infrastructure: [
    "/infrastructure/chemistry/class-1.JPG",
    "/infrastructure/chemistry/class-2.JPG",

    "/infrastructure/chemistry/lab-1.JPG",
    "/infrastructure/chemistry/lab-4.JPG",
    "/infrastructure/chemistry/lab-2.JPG",
    "/infrastructure/chemistry/lab-3.JPG",

    "/infrastructure/chemistry/lab-5.JPG",
    "/infrastructure/chemistry/lab-6.JPG",

    "/infrastructure/chemistry/lab-8.JPG",
    "/infrastructure/chemistry/lab-9.JPG",
    "/infrastructure/chemistry/lab-10.JPG",
    "/infrastructure/chemistry/lab-11.JPG",
    "/infrastructure/chemistry/lab-12.JPG",
    "/infrastructure/chemistry/lab-13.JPG",

    "/infrastructure/chemistry/lab-18.JPG",
    "/infrastructure/chemistry/lab-19.JPG",
    "/infrastructure/chemistry/lab-20.JPG",
    "/infrastructure/chemistry/lab-21.JPG",

  ]
};
